import { useTypingUsers } from "@/hooks/use-typing-indicator";
import { useUser } from "@/hooks/use-user";
import { cn } from "@/lib/utils";

type TypingIndicatorProps = {
	channelId: string | undefined;
	className?: string;
};

export function TypingIndicator({
	channelId,
	className,
}: TypingIndicatorProps) {
	const typingUserIds = useTypingUsers(channelId);
	const { getUserDisplayName } = useUser();

	if (typingUserIds.length === 0) {
		return null;
	}

	const names = typingUserIds.map((uid) => getUserDisplayName(uid));
	let text: string;

	if (names.length === 1) {
		text = `${names[0]} is typing...`;
	} else if (names.length === 2) {
		text = `${names[0]} and ${names[1]} are typing...`;
	} else {
		const othersCount = names.length - 2;
		text = `${names[0]}, ${names[1]}, and ${othersCount} ${othersCount === 1 ? "other is" : "others are"} typing...`;
	}

	return (
		<div
			className={cn(
				"flex items-center gap-2 px-4 py-1 text-muted-foreground text-xs",
				className
			)}
		>
			<TypingDots />
			<span>{text}</span>
		</div>
	);
}

function TypingDots() {
	return (
		<div className="flex items-center gap-0.5">
			<span className="size-1.5 animate-bounce rounded-full bg-muted-foreground [animation-delay:0ms]" />
			<span className="size-1.5 animate-bounce rounded-full bg-muted-foreground [animation-delay:150ms]" />
			<span className="size-1.5 animate-bounce rounded-full bg-muted-foreground [animation-delay:300ms]" />
		</div>
	);
}
